import React from 'react'

import Select, { Option } from 'rc-select'
import 'rc-select/assets/index.css'

// import 'react-select/dist/react-select.css';
import styled, { injectGlobal } from 'styled-components'

import { colors } from '../utils/style-utils'
import arrow from '../img/select.svg'

const SelectWrapper = styled.div`
  select::-ms-expand {
    display: none;
  }

  &.is-subtle {
    .rc-select,
    .rc-select-dropdown {
      border-width: 1px !important;
      border-color: rgba(255, 255, 255, 0.6);
    }
    .rc-select-dropdown,
    .rc-select,
    .rc-select-selection {
      font-size: 12px !important;
      position: relative !important;
      min-height: 36px !important;
      line-height: 36px !important;
    }
  }
`

injectGlobal`
  .rc-select-dropdown,
  .rc-select,
  .rc-select-selection {
    && {
      font-size: 16px;
      position: relative;
      border: 0;
      min-height: 50px;
      line-height: 50px;
      border-radius: 0;
      background: ${colors.black};
      color: ${colors.white};
      .rc-select-selection__rendered {
        line-height: inherit;
        min-height: inherit;
      }
    }
  }

  .rc-select-arrow {
    && {
      top: 50%;
      transform: translateY(-50%);
      b {border-top-color: ${colors.white};}
    }
  }

  .rc-select-open .rc-select-arrow b {
    border-bottom-color: ${colors.white};
  }

  .rc-select-dropdown {
    && {
      border: 3px solid ${colors.white};
      border-top: 0;      
      box-shadow: none;
      line-height: 1.5;
    }
  }

  .rc-select-selection__placeholder {
    && {
      color: ${colors.white};
    }
  }

  .rc-select {
    && {
      width: 100%;
      border: 3px solid ${colors.white};
      margin: 0;
    }
  }
`

const SelectBox = ({ subtle, value, onChange, options, placeholder, name }) => {
  return (
    <SelectWrapper className={subtle && 'is-subtle'}>
      <Select
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        value={value ? value : undefined}
      >
        {options.map(option => (
          <Option key={option.name} value={option.name}>
            {option.name}
          </Option>
        ))}
      </Select>
    </SelectWrapper>
  )
}

export default SelectBox



// WEBPACK FOOTER //
// ./src/components/SelectBox.js